import type { CustomerEnrichmentPort } from '../domain/customer-enrichment'

const requestCustomerEnrichment = async (port: CustomerEnrichmentPort, customerId: string): Promise<void> => {
	await port.request(customerId)
}

export { requestCustomerEnrichment }
